import { render, staticRenderFns } from "./Forgetpw.vue?vue&type=template&id=4f78ecba&"
import script from "./Forgetpw.vue?vue&type=script&lang=js&"
export * from "./Forgetpw.vue?vue&type=script&lang=js&"
import style0 from "./Forgetpw.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports